﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyStickToTop", [
    "StickToTopManager",
    function (StickToTopManager) {
      return {
        link: function ($scope, $element, $attrs) {
          var managedElement = StickToTopManager.setupElement($element, $attrs.tyStickToTopPlaceholderClass);

          $scope.$on("$destroy", function () {
            managedElement.teardown();
          });
        },
      };
    },
  ]);
})(window.angular);
